import styles from 'styles/DownloadScreen.module.css'
import uploadIcon from 'assets/images/common/uploadIcon.svg'

type DownloadScreenPropsType = {
  selectedAvatar: string;
  url?: string;
}

const urls : { [key: string]: any } = {
  'pirate': ' https://firebasestorage.googleapis.com/v0/b/whjr-arts.appspot.com/o/pirate.wick?alt=media&token=77fb1af5-85ab-43c4-b314-6e5b96924393',
  'space explorer': 'https://firebasestorage.googleapis.com/v0/b/whjr-arts.appspot.com/o/space.wick?alt=media&token=7884b9f8-127e-4578-b577-3fd7af2e4aa8',
  'wizard': 'https://firebasestorage.googleapis.com/v0/b/whjr-arts.appspot.com/o/wizard.wick?alt=media&token=1506a4fb-2611-4768-a0a5-d6394637606f',
};


function DownloadScreen({ selectedAvatar, url}: DownloadScreenPropsType) {

  const onClickDownload = () => {
    if(url){
      window.open(url)
    }else{
      window.open(urls[selectedAvatar])
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        Download Project File
      </div>
      <div className={styles.imagesContainer}>
        <img
          src={uploadIcon}
          alt='downloadFile'
          className={styles.image}
        />
      </div>
      <div className={styles.button} onClick={onClickDownload}>
        DOWNLOAD
      </div>
    </div>
  )
}

export default DownloadScreen
